<div class="row col-12 p-0 m-0 main-page-section ">
    <!-- <div class="p-0">
              <app-side-nav [item]="meetingNav"></app-side-nav>
          </div> -->
    <div class="col-12 p-0 employee-section">
        <!-- <app-header></app-header> -->
        <div class="col-height">

            <div>

                <div class="breadcrumbs-section padding-left">
                    <span class="prev-page pt-1 "><a routerLink="/overview">Home</a></span>
                    <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
                    <span class="prev-page pt-1"><a (click)="navigateToList()" style="cursor: pointer;">Meeting Room
                            List</a></span>
                    <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
                    <span class="prev-page pt-1"><a (click)="navigateToDetail()" style="cursor: pointer;">Meeting Room
                            Details</a></span>
                    <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
                    <span class="curr-page  breadcrumbs-section-font">{{meetingRoomName}}</span>
                </div>

                <div class="history-layout">
                    <div class="row pb-3">
                        <div class="col-9">
                            <h1>{{meetingRoomName}}</h1>
                        </div>
                        <div class="col-3"><button (click)="navigateToDetail()">View Meeting Room Details</button></div>
                    </div>
                </div>


                <div class="col-12 d-flex justify-content-start row borders m-0 p-0 mb-2 ">
                    <div class="col-3 borders-right d-flex justify-content-start relative-content">
                        <div class="pt-3 pb-3" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                            [ngbPopover]="popMeetingRooms" triggers="manual" #p1="ngbPopover"
                            (click)="openPopover(p1,0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
                            class=" meeting-label center-align box-size pointer-link text-center meeting-room-head">
                            <div style="width: 100px;">Booking Status</div>
                            <img src="../../assets/images/Path.png" class="pr-3  access-point-arrow" loading="lazy" />
                            <div class="bold-font">{{BookingStatusText}}</div>

                            <div>
                                <ng-template #popMeetingRooms>
                                    <div class="dashboard-popover ">
                                        <div class="">
                                            <div class="">
                                                <div class="row pb-3 d-flex justify-content-start pointer-link"
                                                    [ngClass]="BookingStatusText==item.statusText?'bold-font ':'normal-font'"
                                                    *ngFor="let item of BookingStatus;let i=index"
                                                    (click)="setStatus(item)">
                                                    {{item.statusText}}
                                                    <div>
                                                        <img *ngIf="BookingStatusText==item.statusText"
                                                            class="pl-5 ml-4" src="/assets/images/tick.png">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>

                    <div class="pt-3 pb-3 col-2 borders-right">
                        <span class="text pt-3" style=" position: absolute; margin-left: 31px;margin-top: -14px;">From
                            Date</span>
                        <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d4.toggle()" [(ngModel)]="fDate"
                            ngbDatepicker #d4="ngbDatepicker" (dateSelect)="updateSelectedFromDate($event)">
                        <div class="meeting-sub-label from-date">{{formattedSelectedFromDate}}</div>
                    </div>
                    <div class="pt-3 pb-3 col-2 borders-right">
                        <span class="text pt-3" style=" position: absolute; margin-left: 31px;margin-top: -14px;">To
                            Date</span>
                        <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d2.toggle()" [(ngModel)]="tDate"
                            ngbDatepicker #d2="ngbDatepicker" (dateSelect)="updateSelectedToDate($event)">
                        <div class="meeting-sub-label from-date">{{formattedSelectedToDate}}</div>
                    </div>
                    <div class="col-5"></div>
                </div>

                <empty-state *ngIf="meetingRoomBookedDetails?.length==0"></empty-state>

                <div *ngIf="meetingRoomBookedDetails?.length>0">
                    <div class="view-layout mt-5">

                        <div class="row pr-4 " *ngIf="BookStatusValue==true">
                            <div class="col-10"></div>
                            <div class="col-2  d-flex justify-content-end ">
                                <label class="check-container">
                                    <input type="checkbox" [checked]="selectAll" [(ngModel)]="selectAll"
                                        value="selectAll" (change)="toggleSelectAllSelection($event)">
                                    <span class="checkmark" style="margin-top: 13px;"></span>
                                </label>
                                <p class=" pt-3 text-select justify-content-end">select all</p>

                                <div class="list-option " (clickOutside)="onClickedOutside($event)"
                                    [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #p2="ngbPopover"
                                    (click)="$event.stopPropagation();openPopover(p2,0)" placement="bottom">
                                    <div class="dot"></div>
                                    <div class="dot"></div>
                                    <div class="dot"></div>
                                    <ng-template #popContent>
                                        <div>
                                            <div class="popover-content" style="cursor: pointer;"
                                                (click)="cancelBooking();openPopover(p2,0)">
                                                Cancel Booking</div>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>

                        <div class="list-container mb-2 pb-4"
                            *ngFor="let list of meetingRoomBookedDetails | filter:searchText | paginate: {itemsPerPage: pageSize, currentPage: pageNo, totalItems:totalCountList};let i=index">
                            <div class="row">

                                <div class="col-1" style="padding-left: 3%;"
                                    *ngIf="BookStatusValue==true&&compareDate(list?.startDate)">
                                    <label class="check-container">
                                        <input type="checkbox"
                                            (change)="toggleSelection($event,list?.meetingRoomBookingId)"
                                            [value]="multiSelectBookingId?.includes(list?.meetingRoomBookingId)"
                                            [checked]="multiSelectBookingId?.includes(list?.meetingRoomBookingId)">
                                        <span class="checkmark" style="margin-top: 13px;"></span>
                                    </label>
                                </div>

                                <div class="col-10">
                                    <div class="row">
                                        <div class="col-12 name">
                                            {{list?.name}}
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-12 detail">
                                            {{list?.company}}&nbsp;|&nbsp;{{formatDate(list?.startDate)}}&nbsp;|&nbsp;{{formatTime(list?.startDate)}}-{{formatTime(list?.endDate)}}&nbsp;|&nbsp;{{list?.duration
                                            + ' ' + list?.durationType}}&nbsp;|&nbsp;{{'₹'
                                            + list?.totalAmount}}
                                            <!-- <span
                                                *ngIf="list?.isDisbursed==true"
                                                class="textGreen">|&nbsp;Disbursed
                                            </span> -->
                                        </div>
                                    </div>
                                </div>

                                <div class="col-1 pt-3" *ngIf="BookStatusValue==true">
                                    <div class="list-option " (clickOutside)="onClickedOutside($event)"
                                        *ngIf="compareDate(list?.startDate)" [autoClose]="'outside'"
                                        [ngbPopover]="popContent1" triggers="manual" #p1="ngbPopover"
                                        (click)="$event.stopPropagation();openPopover(p1,list?.meetingRoomBookingId)"
                                        placement="bottom">
                                        <div class="dot"></div>
                                        <div class="dot"></div>
                                        <div class="dot"></div>
                                        <ng-template #popContent1>
                                            <div>
                                                <div class="popover-content"
                                                    (click)="$event.stopPropagation();cancelBooking();openPopover(p1,list?.meetingRoomBookingId)"
                                                    style="cursor: pointer;">Cancel Booking
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center pagination-section" *ngIf="totalCountList > 10">
                    <div class="row d-flex pagination-border">
                        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)"
                            nextLabel="" class="d-flex justify-content-center">
                        </pagination-controls>
                        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="creditPoint?.length>=10">10/{{creditPoints?.length}}</div> -->
                        <div class="pr-3 ratio-class pt-1">
                            {{pageNo}}/{{fetchPage(totalCountList)}}</div>
                    </div>
                </div>
            </div>
        </div>